import { render, staticRenderFns } from "./EditAttribute.vue?vue&type=template&id=1038c93c&scoped=true"
import script from "./EditAttribute.vue?vue&type=script&lang=js"
export * from "./EditAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1038c93c",
  null
  
)

export default component.exports